import { render } from "./InventoryPlanIndex.vue?vue&type=template&id=40aedb48&scoped=true"
import script from "./InventoryPlanIndex.vue?vue&type=script&lang=js"
export * from "./InventoryPlanIndex.vue?vue&type=script&lang=js"

import "./InventoryPlanIndex.vue?vue&type=style&index=0&id=40aedb48&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-40aedb48"]])

export default __exports__